/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Supplement } from './Supplement';
import {
    SupplementFromJSON,
    SupplementFromJSONTyped,
    SupplementToJSON,
    SupplementToJSONTyped,
} from './Supplement';

/**
 * Paginated list of supplements
 * @export
 * @interface ListSupplementsResponse
 */
export interface ListSupplementsResponse {
    /**
     * 
     * @type {Array<Supplement>}
     * @memberof ListSupplementsResponse
     */
    items: Array<Supplement>;
    /**
     * 
     * @type {number}
     * @memberof ListSupplementsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ListSupplementsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ListSupplementsResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the ListSupplementsResponse interface.
 */
export function instanceOfListSupplementsResponse(value: object): value is ListSupplementsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function ListSupplementsResponseFromJSON(json: any): ListSupplementsResponse {
    return ListSupplementsResponseFromJSONTyped(json, false);
}

export function ListSupplementsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSupplementsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SupplementFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function ListSupplementsResponseToJSON(json: any): ListSupplementsResponse {
    return ListSupplementsResponseToJSONTyped(json, false);
}

export function ListSupplementsResponseToJSONTyped(value?: ListSupplementsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(SupplementToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

